
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dr/[slug]",
      function () {
        return require("private-next-pages/dr/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dr/[slug]"])
      });
    }
  